import { useState, useEffect } from "react";
import { useDispatch, useStore } from "react-redux";
import _ from "lodash";

import { Card } from '@mui/material';

import { ListDisplay } from '../../Component/ListDisplay/ListDisplay';

import { constants } from '../../Constants/constants';
import { getList } from "../../helper/baseFetch";
import { setRestaurant } from "../../actions/restaurantAction";
import { getSalesName } from "../../Component/SalesName/getSalesName";
import { generateTableCellToMultiLanguageName } from "../../helper/util";

export const SalesRestaurantList = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const [salesRestaurantList, setRestaurantList] = useState([]);
  const [ready, setReady] = useState(false);
  const resourceName = "salesRestaurant";

  const listTitles = [
    {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "restUrlId",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.IMAGE,
      value: "logoImage",
      sort: false
    }, {
      key: constants.LIST_DISPLAY_TYPE.IMAGE,
      value: "shopFrontImage",
      sort: false
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "name",
      sort: false,
      minSize: true,
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "address",
      sort: false,
      minSize: true,
    }, {
      key: constants.LIST_DISPLAY_TYPE.DATE_TIME,
      value: "salesCreateTimestamp",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.BOOLEAN,
      value: "uploadedContractSignature",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "approvalStatus",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "paymentStatus",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.DATE_TIME,
      value: "updateTimestamp",
      sort: true
    }
  ];
  const listFilters = [
    {
      className: "filter-input",
      label: { resource: resourceName, key: "restUrlId" },
      clear: true,
      value: '',
      name: "restUrlId",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resourceName, key: "name" },
      clear: true,
      value: '',
      name: "name",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resourceName, key: "address" },
      clear: true,
      value: '',
      name: "address",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resourceName, key: "salesName" },
      value: '',
      type: constants.TYPE.SELECT,
      selectValue: [],
      name: "salesName",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resourceName, key: "uploadedContractSignature" },
      value: '',
      type: constants.TYPE.SELECT,
      selectValue: constants.CHOICES.RESTAURANT_APPROVE.UPLOADEDCONTRACTSIGNATURE,
      name: "uploadedContractSignature",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resourceName, key: "approvalStatus" },
      value: '',
      type: constants.TYPE.SELECT,
      selectValue: constants.CHOICES.RESTAURANT_APPROVE.STATUS,
      name: "approvalStatus",
      size: constants.SIZE.SMALL
    }
  ];

  const [param, setParam] = useState({
    path: "",
    page: 0,
    rowsPerPage: 10,
    sort: 'updateTimestamp',
    direction: 'DESC',
    listFilters: listFilters,
    count: 0,
  })

  function onChangeParam(value) {
    value.count = value.count + 1;
    setParam(value);
  }

  function onChangeListFilters(list) {
    let tempParam = _.cloneDeep(param);
    tempParam.listFilters = list;
    tempParam.page = 0;
    onChangeParam(tempParam);
  }

  function onChangeListSort(sortItem) {
    let tempParam = _.cloneDeep(param);
    tempParam.sort = sortItem;
    tempParam.direction = tempParam.direction === "DESC" ? "ASC" : "DESC";
    onChangeParam(tempParam);
  }

  function onChangeListPage(page) {
    let tempParam = _.cloneDeep(param);
    tempParam.page = page;
    onChangeParam(tempParam);
  }

  function onChangeListRowsPerPage(rowsPerPage) {
    let tempParam = _.cloneDeep(param);
    tempParam.page = 0;
    tempParam.rowsPerPage = rowsPerPage;
    onChangeParam(tempParam);
  }

  const handleSalesName = async () => {
    let salesName = await getSalesName(param, store);
    setParam(salesName);
    setReady(true);
    return salesName;
  }

  useEffect(() => {
    dispatch(setRestaurant([]));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let tempParam = _.cloneDeep(param);
    const filter = {};
    tempParam.listFilters.forEach((filterItem) => {
      if (filterItem.value !== '' && filterItem.value !== undefined) {
        filter[filterItem.name] = filterItem.value;
      }
    })

    getList(constants.PATH.SALES.SALES_RESTAURANT, { sort: { field: tempParam.sort, order: tempParam.direction }, filter: filter, pagination: { page: tempParam.page + 1, perPage: tempParam.rowsPerPage } }, (payload) => {
      payload.map((item) => {
        item.name = generateTableCellToMultiLanguageName(item.tcName, item.enName, item.scName);
        item.address = generateTableCellToMultiLanguageName(item.tcAddress, item.enAddress, item.scAddress);
        return item
      });
      setRestaurantList(payload);
      if (!ready) {
        handleSalesName();
      }
    }, undefined, store);
  }, [param.count]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    ready &&
    <Card className="card-wrapper overflow">
      <ListDisplay
        page={param.page}
        rowsPerPage={param.rowsPerPage}
        onChangeListSort={onChangeListSort}
        resource={resourceName}
        dataList={salesRestaurantList}
        sort={param.sort}
        direction={param.direction}
        listTitles={listTitles}
        listFilters={param.listFilters}
        onChangeListPage={onChangeListPage}
        onChangeListRowsPerPage={onChangeListRowsPerPage}
        editBtn={true}
        createBtn={false}
        onChangeListFilters={onChangeListFilters}
        redirectPath={"/" + (constants.PATH.APPROVAL.RESTAURANT) + "/"}
      />
    </Card>
  )
};
